import { useState } from 'react';

import { useVerifyEmailPopup } from 'features/account/verify-email/useVerifyEmailPopup';
import { useGlobalError } from 'hooks/useGlobalError';
import { useAuth } from 'providers/AuthProvider';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';
import { userService } from 'services/user/userService';

import { useUpdateMyProfileDetailsAlerts } from './useUpdateMyProfileDetailsAlerts';

type UpdateEmailOpts = { onPopupClose?: () => void };

export const useUpdateEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showVerifyEmailPopup } = useVerifyEmailPopup();
  const { appLogout } = useAuth();
  const { unknownError } = useGlobalError();
  const { userDetailsUpdated } = useUpdateMyProfileDetailsAlerts();
  const { refreshCurrentUser } = useCurrentUser();

  const editEmailAndShowConfirmationPopup = async (email: string, opts?: UpdateEmailOpts) => {
    setIsLoading(true);
    try {
      await userService.updateEmail(email);
      showEmailConfirmationPopup(email, opts);
    } catch {
      unknownError();
    } finally {
      setIsLoading(false);
    }
  };

  const showEmailConfirmationPopup = (email: string, opts?: UpdateEmailOpts) => {
    showVerifyEmailPopup(
      email,
      undefined,
      async () => {
        userDetailsUpdated();
        appLogout();
      },
      () => {
        opts?.onPopupClose?.();
        refreshCurrentUser();
      },
      'EmailChange'
    );
  };

  return { editEmailAndShowConfirmationPopup, isLoading, showEmailConfirmationPopup };
};
